import styled from 'styled-components';

export type ButtonProps = {
  $w?: string;
  $p?: string;
  $wSM?: string;
  $negative?: boolean;
  $green?: boolean;
  $gray?: boolean;
  $yellow?: boolean;
  $darkBlue?: boolean;
  $selected?: boolean;
  $whiteBlue?: boolean;
  $whiteDarkBlue?: boolean;
  $whiteRed?: boolean;
  $blue?: boolean;
  $medium?: boolean;
  $small?: boolean;
  $smallSM?: boolean;
  $m?: string;
  $mt?: number | string;
  $mb?: number | string;
  $ml?: number | string;
  $mr?: number | string;
  $maxWidth?: string;
  $pSM?: string;
  $mSM?: string;
  $mtSM?: number | string;
  $mbSM?: number | string;
  $mlSM?: number | string;
  $mrSM?: number | string;
  $maxWidthSM?: string;
  $blueGradient?: boolean;
  $gradientBorderText?: boolean;
  $loading?: boolean;
  $success?: boolean;
  $xButton?: boolean;
  onXButtonClick?: (e: React.MouseEvent<HTMLElement>) => void;
  $loadingColor?: string;
  $tooltip?: string;
};

export const ButtonStyled = styled.button<ButtonProps>`
  position: relative;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.primary};
  background: none;
  border-radius: 100px;
  box-shadow: 0 0 0 1px ${({ theme }) => theme.primary};
  border: none;
  width: ${({ $w }) => ($w ? $w : '180px')};
  overflow: hidden;
  transition: all 100ms ease-in;
  font-weight: bold;
  z-index: 1;
  cursor: pointer;
  font-size: 14px;
  padding: 0 12px;
  ${({ $p }) => $p && 'padding: 0 30px;'};

  /* A button showing its spinner is mid-request — swallow further clicks so it
     can't be spammed. Done here rather than with the disabled attribute so the
     button keeps its own colors (:disabled greys it out) while it works. */
  ${({ $loading }) =>
    $loading &&
    `
    pointer-events: none;
    cursor: default;
  `};

  ${({ $tooltip }) =>
    $tooltip &&
    `
    overflow: visible;
  `}

  @media (min-width: 3500px) {
    padding: 0 60px;
    font-size: 26px;
    width: ${({ $w }) => ($w ? $w : '300px')};
    height: 70px;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.primary};
  }

  @media (max-width: 800px) {
    width: ${({ $wSM }) => ($wSM ? $wSM : '150px')};
  }

  @media (max-width: 380px) {
    height: 40px;
    font-size: 12px;
    width: ${({ $wSM }) => ($wSM ? $wSM : '120px')};
  }

  ::before {
    position: absolute;
    content: '';
    top: 0;
    bottom: 0;
    z-index: -1;
    left: 0;
    right: 0;
    transition: all 0.2s ease-out;
    transform: translateX(-110%);
    background: ${({ theme }) => theme.primary};
    border-radius: 100px;
  }

  :hover {
    color: ${({ theme }) => theme.white};

    svg {
      path {
        fill: ${({ theme }) => theme.white};
      }
    }
  }

  :hover::before {
    transform: translateX(0);
  }

  :active {
    transform: translateY(3px);
  }

  ${({ $negative }) =>
    $negative &&
    `
    border: 1px solid #f2f2f2;
    box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.1);
  `}

  ${({ $green, theme }) =>
    $green &&
    `
    border: none;
    ::before {
      background: ${theme.green};
      }
    box-shadow: none;
  `};

  ${({ $gray, theme }) =>
    $gray &&
    `
    color: ${theme.darkGray};
    box-shadow: 0 0 0 1px ${theme.darkGray};

    ::before {  
      background: ${theme.darkGray};
      color: ${theme.white};
    };

  `};

  ${({ $yellow, theme }) =>
    $yellow &&
    `
    color: ${theme.yellow};
    box-shadow: 0 0 0 1px ${theme.yellow};

    ::before {
      background: ${theme.yellow};
      color: ${theme.white};
    };

  `};

  ${({ $darkBlue, theme }) =>
    $darkBlue &&
    `
    color: ${theme.darkBlue};
    box-shadow: 0 0 0 1px ${theme.darkBlue};

    ::before {
      background: ${theme.darkBlue};
      color: ${theme.white};
    };

  `};

  ${({ $selected, theme }) =>
    $selected &&
    `
     color: ${theme.white};
     ::before {
      transform: translateX(0);
      }

   
  `}

  ${({ $whiteBlue, theme, $selected }) =>
    $whiteBlue &&
    `
    background: ${theme.blue};
    color: ${theme.white};
    box-shadow: 0 0 0 1px ${theme.white};

    ::before {
      background: ${theme.white};
      color: ${theme.blue};
    };

    :hover {
      color: ${theme.blue};
    }

    ${$selected && ` color: ${theme.blue};`}

    
   

  `};

  ${({ $whiteDarkBlue, theme, $selected }) =>
    $whiteDarkBlue &&
    `
    color: ${theme.white};
    box-shadow: 0 0 0 1px ${theme.white};

    ::before {
      background: ${theme.white};
      color: ${theme.darkBlue};
    };


  :hover {
    color: ${theme.darkBlue};
  }

  `};

  ${({ $whiteRed, theme, $selected }) =>
    $whiteRed &&
    `
    background: ${theme.white};
    color: ${theme.primary};
    box-shadow: 0 0 0 1px ${theme.white};

    ::before {
      background: ${theme.white};
      color: ${theme.primary};
    };

    :hover {
      color: ${theme.primary};
    }

    ${$selected && ` color: ${theme.primary};`}
  `};

  ${({ $blue, theme, $selected }) =>
    $blue &&
    `
    color: ${theme.blue};
    box-shadow: 0 0 0 1px ${theme.blue};


    ::before {
      background: ${theme.blue};
      color: ${theme.white};
    };


  :hover {
    color: ${theme.white};
  }
    ${$selected && ` color: ${theme.white};`}

  `};

  ${({ $blueGradient, theme, $selected }) =>
    $blueGradient &&
    `

    ::before {
     background: linear-gradient(90deg, #306FDE 0.11%, #3A6BDB 32.44%, #7F50C7 68.63%, #BA39B5 100.48%);

    };
    background: none;
    :hover {
     box-shadow: none;
    }

    box-shadow: none;
    position: relative;

    span {
      background: linear-gradient(90deg, #306FDE 0.11%, #3A6BDB 32.44%, #7F50C7 68.63%, #BA39B5 100.48%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      padding: 1px;
      background: linear-gradient(90deg, #306FDE 0.11%, #3A6BDB 32.44%, #7F50C7 68.63%, #BA39B5 100.48%);
      border-radius: 100px;
      -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
      -webkit-mask-composite: xor;
      mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
      mask-composite: exclude;
      pointer-events: none;
    }

    ::before {
      background: linear-gradient(90deg, #306FDE 0.11%, #3A6BDB 32.44%, #7F50C7 68.63%, #BA39B5 100.48%);
    }

    :hover {
      box-shadow: none;
      span {
        -webkit-text-fill-color: ${theme.white};
        background: none;
        color: ${theme.white};
      }
    }

    ${
      /* $selected fills the button with the gradient (::before slides in), so the
         gradient-clipped text/icon would sit on the same gradient and vanish —
         force them white, matching the hover treatment above. */
      $selected
        ? `
      span {
        -webkit-text-fill-color: ${theme.white};
        background: none;
        color: ${theme.white};
      }

      svg path {
        fill: ${theme.white};
      }
    `
        : ''
    }
  `};

  /* Filled gradient (whole button): $selected reveals the gradient ::before
     fill, so the text (and any icon) must be solid white instead of
     gradient-clipped / gradient-filled, which would blend into the fill. */
  ${({ $blueGradient, $selected, theme }) =>
    $blueGradient &&
    $selected &&
    `
    span {
      -webkit-text-fill-color: ${theme.white};
      background: none;
      color: ${theme.white};
    }
    svg path {
      fill: ${theme.white};
    }
  `};

  /* aria-disabled looks the same but still takes the click, for a button
     that should say WHY it cannot be pressed instead of ignoring the tap. */
  :disabled,
  &[aria-disabled='true'] {
    cursor: not-allowed;

    box-shadow: 0 0 0 1px ${({ theme }) => theme.darkGray};
    opacity: 0.5;
    color: ${({ theme }) => theme.darkGray};
    span {
      cursor: not-allowed;
    }
    ::before {
      background: ${({ theme }) => theme.darkGray};
      color: ${({ theme }) => theme.white};
      span {
        color: ${({ theme }) => theme.white};
      }
      cursor: not-allowed;
    }
    ${({ $selected, theme }) =>
      $selected &&
      `
      color: ${theme.white};
      `}
    :hover {
      span {
        color: ${({ theme }) => theme.white};
      }
    }
  }

  ${({ $medium, $w }) =>
    $medium &&
    `
    font-weight: normal;
    height: 40px;
    width: ${$w ? $w : 'auto'};
    font-size: 15px;
  `}

  ${({ $small, $w }) =>
    $small &&
    `
    height: 32px;
    width: ${$w ? $w : '140px'};
    font-size: 14px;
  `}

  margin: ${(props) => props.$m};
  margin-top: ${(props) => props.$mt}px;
  margin-bottom: ${(props) => props.$mb}px;
  margin-left: ${(props) => props.$ml}px;
  margin-right: ${(props) => props.$mr}px;
  max-width: ${(props) => props.$maxWidth};

  @media (max-width: 800px) {
    width: ${({ $wSM }) => ($wSM ? $wSM : '100%')};
    ${({ $pSM }) => $pSM && 'padding: 0 15px;'};

    margin: ${(props) => props.$mSM};
    margin-top: ${(props) => props.$mtSM}px;
    margin-bottom: ${(props) => props.$mbSM}px;
    margin-left: ${(props) => props.$mlSM}px;
    margin-right: ${(props) => props.$mrSM}px;
    max-width: ${(props) => props.$maxWidthSM};

    ${({ $medium, $w }) =>
      $medium &&
      `
    font-weight: normal;
    height: 40px;
    width: ${$w ? $w : 'auto'};
    font-size: 14px;
  `}

    ${({ $small, $wSM }) =>
      $small &&
      `
    height: 32px;
    width: ${$wSM ? $wSM : '100px'};
    font-size: 12px;
    flex: none;
  `}

${({ $smallSM, $wSM }) =>
      $smallSM &&
      `
    height: 32px;
    width: ${$wSM ? $wSM : '100px'};
    font-size: 12px;
    flex: none;
  `}
  }

  ${({ $loading, $success, $xButton }) =>
    ($loading || $success || $xButton) &&
    `
   position: relative;
 
  `}
`;
